module.exports = __webpack_public_path__ + "static/media/1.Complete range of Paint gun.165bf99c.jpeg";